import React, { useState } from 'react';
import { SelectionGroupValue } from 'fronton-react/selection-group/types';
import { SelectionGroup, SelectionGroupItem } from 'fronton-react';
import cn from 'clsx';
import { createElementKey } from 'utils';
import { Button , Section, SectionSubTitle, Typography} from 'common/components';
import { COMMON_LANDINGS_IMAGES_CDN_PATH } from 'common/constants/common';
import { CreditBlockModal } from './credit-block-modal';
import {
  creditBlock,
  creditBlockButton,
  creditBlockInfo,
  creditBlockInfoText,
  creditBlockInfoWrapper,
  creditBlockImage,
  creditBlockImageTop,
  creditBlockOverpaymentText,
  creditBlockPercent,
  creditBlockPercentWithOverpayment,
  creditBlockPeriodItem,
  creditBlockPeriodItemActive,
  creditBlockPeriodList,
  creditBlockTitleWrapper,
  creditBlockPeriodItemUnit,
  creditBlockPeriodItemUnitActive,
  creditBlockPeriodItemValue,
} from './credit-block-styles';

const CREDIT_PERIOD_LIST = [6, 10, 12, 18, 24];
const OVERPAYMENT_MAP: Record<number, number> = {
  6: 0,
  10: 0,
  12: 3,
  18: 9,
  24: 15,
};

export const CreditBlock: React.FC = () => {
  const [activePeriod, setActivePeriod] = useState(CREDIT_PERIOD_LIST[0]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isOverpayment = activePeriod > 10;

  const handleChangePeriod = (_: React.MouseEvent, value: SelectionGroupValue) => {
    setActivePeriod(value as number);
  }

  const handleClickMoreDetailsBtn = () => {
    setIsModalOpen(true);
  }

  const handleCloseModal = () => {
    setIsModalOpen(false);
  }

  return (
    <Section>
      <img
        alt="Изображение калькулятора с процентами"
        className={creditBlockImageTop}
        src={`${COMMON_LANDINGS_IMAGES_CDN_PATH}/credit-block/credit-image-m.jpg/credit-image-m.jpg`}
      />

      <div className={creditBlockTitleWrapper}>
        <SectionSubTitle margin='none'>
          Покупайте сейчас&nbsp;&mdash; платите потом
        </SectionSubTitle>
        <Typography variant="l" size="body_long">
          Кредит без первоначального взноса
        </Typography>
      </div>

      <div className={creditBlock}>
        <div className={creditBlockInfo}>
          <div className={creditBlockInfoWrapper}>
            <Typography className={creditBlockInfoText} variant="l" size="body_long" color="text-secondary">
              {isOverpayment ? 'Кредит\nна большие цели' : 'Кредит\nбез переплат'}
            </Typography>

            <div>
              <Typography
                className={cn(creditBlockPercent, { [creditBlockPercentWithOverpayment]: isOverpayment })}
                color="secondary-green-primary"
                variant="display"
              >
                {OVERPAYMENT_MAP[activePeriod]}%
              </Typography>
              {isOverpayment && (
                <Typography className={cn(creditBlockOverpaymentText)} variant="m" size="body_long" color="text-secondary">
                  переплата
                </Typography>
              )}
            </div>
          </div>

          <div>
            <SelectionGroup
              active={activePeriod}
              className={creditBlockPeriodList}
              onChange={handleChangePeriod}
            >
              {CREDIT_PERIOD_LIST.map((period, index) => (
                <SelectionGroupItem
                  className={cn(creditBlockPeriodItem, { [creditBlockPeriodItemActive]: activePeriod === period })}
                  key={createElementKey('credit-block-period', index)}
                  value={period}
                >
                  <Typography className={creditBlockPeriodItemValue} variant="l" size="body_long">{period}</Typography>
                  <Typography
                    className={cn(creditBlockPeriodItemUnit, { [creditBlockPeriodItemUnitActive]: activePeriod === period })}
                    variant="l"
                    size="body_long"
                  >
                    мес
                  </Typography>
                </SelectionGroupItem>
              ))}
            </SelectionGroup>
            <Button
              adaptive={false}
              className={creditBlockButton}
              onClick={handleClickMoreDetailsBtn}
              invert
              variant="primary"
              wide
            >
              Подробнее
            </Button>
          </div>
        </div>
        <img
          alt="Изображение калькулятора с процентами"
          className={creditBlockImage}
          src={`${COMMON_LANDINGS_IMAGES_CDN_PATH}/credit-block/credit-image.png/credit-image.png`}
        />
      </div>

      <CreditBlockModal isOpen={isModalOpen} onClose={handleCloseModal} />
    </Section>
  );
}